/**
 * Whether the current user gets the Material Access page (Admin menu + /portal/material-access).
 *
 * Switched on per campus with CampusPortal.materialAccess = true (Claremont and Test Demo as of
 * 2026-10-02). System admins and developers always get it; everyone else needs at least one of
 * their campuses switched on. Front-end only: the API stays campus-scoped as before.
 */
export const hasMaterialAccessPage = (campuses, { isGlobalAdmin, userCampusIds }) => {
  if (isGlobalAdmin) return true;
  const mine = new Set(userCampusIds || []);
  return (campuses || []).some(c => c.materialAccess === true && mine.has(c.id));
};
